var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSavedButton = function SvgSavedButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.867 15.787a1.66 1.66 0 001.708-.048l3.301-2.064a.336.336 0 01.357 0l3.3 2.064a1.681 1.681 0 002.57-1.425V2.017A2.017 2.017 0 0010.084 0H2.017A2.017 2.017 0 000 2.017v12.297a1.661 1.661 0 00.867 1.473z",
    fill: "#fff"
  })));
};

export default SvgSavedButton;